/**
 * کارتِ تورِ کاربرِ تازه — نسخه‌ی وب (WHOSUP-83). قرینه‌ی
 * `apps/mobile/src/features/tour/TourGuide.tsx`.
 *
 * منطقش این‌جا نیست: قدم‌ها، قدمِ بعدی و «دیده شد» همه در `core/lib/tour.ts`
 * نشسته‌اند و هر دو اپ همان را صدا می‌زنند؛ این فایل فقط رندر است.
 *
 * ═══ چرا یک نوارِ پایین و نه یک مودال ═══
 *
 * تصمیمِ ۲ تیکت: راهنما باید **روی خودِ صفحه** باشد. مودال با پرده‌ی تیره‌اش
 * دقیقاً همان چیزی را می‌پوشاند که دارد درباره‌اش حرف می‌زند، و از آن بدتر
 * کلیکِ کاربر را هم می‌بلعد. این کارت گوشه‌ی پایین می‌نشیند، بقیه‌ی صفحه
 * زنده می‌ماند، و لینکِ هدرِ مربوط به هر قدم همان لحظه برجسته می‌شود
 * (کلاسِ `tour-point` — نگاه کن به Shell و HeaderTabs).
 *
 * ⚠ تور فقط وقتی باز می‌شود که **نمایه** هم آمده باشد، نه فقط نشست: بینِ
 * ورود و آمدنِ ردیفِ نمایه، `CreateProfilePage` روی صفحه است و کارتِ راهنما
 * وسطِ فرمِ ثبت‌نام هیچ معنایی ندارد.
 */
import React, { useEffect } from 'react';
import { t, useLocale } from '@/core/lib/i18n';
import { useSession } from '@/core/session';
import { advanceTour, endTour, openTourIfPending, useTour } from '@/core/lib/tour';

export function TourGuide() {
  useLocale();
  const { session, profile } = useSession();
  const tour = useTour();
  const uid = session?.user?.id;

  // کاربرِ تازه: تور خودش باز می‌شود. برای بقیه این فقط یک خواندنِ
  // localStorage است و چیزی رندر نمی‌شود.
  useEffect(() => {
    if (uid && profile) void openTourIfPending(uid);
  }, [uid, profile?.id]);

  if (!tour) return null;
  const last = tour.index === tour.total - 1;

  return (
    <div className="card tour-card" role="dialog" aria-label={t('tourAgain')} data-testid="tour-card">
      <p className="tour-step">{t('tourProgress', { n: tour.index + 1, total: tour.total })}</p>
      <h3>{t(tour.step.titleKey)}</h3>
      <p className="dim">{t(tour.step.bodyKey)}</p>
      <div className="tour-actions">
        {/* «رد کن» از قدمِ اول هست — تصمیمِ ۳ تیکت. */}
        <button type="button" className="btn ghost" data-testid="tour-skip"
          onClick={() => endTour('skipped')}>
          {t('tourSkip')}
        </button>
        <button type="button" className="btn fill" data-testid="tour-next"
          onClick={advanceTour}>
          {last ? t('tourFinish') : t('tourNext')}
        </button>
      </div>
    </div>
  );
}
